import { InputGroup } from 'react-bootstrap'
import Select from 'react-select'
import range from './Range'
import './GroupSelect.css'
import Help from 'Help';

export function OptionRange(min, max, f) {
	return range(min, max).map(i => { return {value : f(i), label: f(i)}})
}

export function GroupSelect(props) {
	let value={}
	if (props.options !== undefined) {
		value = props.options.find((i) => i.value === props.value)
	}

	return (
		<div className="mb-3 d-flex w-100">
			<InputGroup>
				<InputGroup.Text>{ props.name }</InputGroup.Text>
				<Select
					{...props}
					value={value}
					className="form-control select"
					styles={{
						noOptionsMessage : (base, state) => ({
							...base,
							color : "red"
						})
					}}
				/>
				{props.unit !== undefined ?
					(<InputGroup.Text>{ props.unit }</InputGroup.Text>) : <></>
				}
			</InputGroup>
			{props.info ? <Help info={props.info} /> : <></>}
		</div>
	)
}
